<nz-layout>
    <nz-content>
        <nz-table
            #dynamicTable
            [nzData]="orders"
            [nzPageSize]="100"
            [nzShowTotal]="totalTemplate"
            [nzLoading]="isLoading$ | async"
        >
            <thead>
                <tr>
                    <th nzWidth="60px" nzShowExpand>Check</th>
                    <th
                        *ngFor="let column of listOfColumn"
                        [nzSortFn]="column.compare"
                        [nzSortOrder]="column.sortOrder"
                    >
                        {{ column?.title }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-template ngFor let-data [ngForOf]="dynamicTable.data">
                    <tr
                        (click)="toggleSelection(data.id)"
                        [class]="data.id === checkedId ? 'selected' : ''"
                    >
                        <td
                            [nzChecked]="checkedId == data.id"
                            (nzCheckedChange)="onItemChecked(data.id, $event)"
                        ></td>
                        <td>
                            <a (click)="openOrderDetails(data.id)">
                                #{{ data.id }}
                            </a>
                        </td>
                        <td>{{ data.createdAt | date : 'medium' }}</td>
                        <td>{{ data.shippedAt | date : 'medium' }}</td>
                        <td>{{ statusNames[data.status] }}</td>
                        <td>{{ data.totalAmount | currency }}</td>
                    </tr>
                </ng-template>
            </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total
            >Total {{ total }} items</ng-template
        >
    </nz-content>
    <nz-footer>
        <button nz-button nzType="primary" (click)="chooseOrder()">
            Choose Order
        </button>
    </nz-footer>
</nz-layout>
